import Container from '@/components/container/Container';
import { TextHeadlineExtraLarge } from '@/components/text/Texts';
import '../../authentication-screens.styles.css';

const SuccessScreen = () => {
	return (
		<Container className="sign-up-success-screen">
			<img
				src="/images/creating-account.gif"
				height={245}
				width={245}
				className="-left-[72px] -bottom-16 relative"
				alt="creating account image"
			/>
			<TextHeadlineExtraLarge className="text-black" text="Creating your Xpress for Business account" />
		</Container>
	);
};

export default SuccessScreen;
